// extracted by mini-css-extract-plugin
export default {"wrapper":"money_wrapper__uXLUf"};